<template>
    <div class="newIcon">
        <div class="breadcrumb">
            <span v-if="edit === false">新增入口ICON</span>
            <span v-if="edit !== false">编辑入口ICON</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
                <el-button class="right_f" type="primary" @click="save(0)">保存草稿</el-button>
                <el-button class="right_f" type="primary" @click="save(1)">发布</el-button>
            </span>
        </div>

        <div class="detail">
            <!-- 新增和编辑用户输入表单 -->
            <el-form ref="iconForm" :rules="rules" :model="iconForm" label-width="130px">
                <el-form-item label="广告说明：" prop="description" required>
                    <el-input v-model="iconForm.description" placeholder="广告说明" class="iconTitle"></el-input>
                </el-form-item>

                <select-school :schObj="iconForm.schObj" @changeVal="getVal"></select-school>

                <el-form-item label="开始时间：" required>
                    <el-date-picker v-model="iconForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="timeInput"></el-date-picker>
                    <el-select v-model="iconForm.sHours" placeholder="请选择" class="inline">
                        <el-option v-for="item in hours" :value="item" :label="item" :key="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结束时间：" required>
                    <el-date-picker v-model="iconForm.endTime" class="timeInput" format="yyyy/MM/dd" placeholder="yyyy/MM/dd"></el-date-picker>
                    <el-select v-model="iconForm.eHours" placeholder="请选择" class="inline">
                        <el-option v-for="item in hours" :value="item" :label="item" :key="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="广告曝光代码:" class="prizeContent">
                    <el-input type="textarea" :autosize="{minRows: 5}" placeholder="广告曝光代码" v-model="iconForm.adExposingCodes">
                    </el-input>
                </el-form-item>

                <!--循环添加上传图片upload组件  -->
                <el-row v-for="item in items">
                    <div class="tit">
                        <span>{{item.title}}：</span>
                        <el-select v-model="item.order" placeholder="请选择顺序" class="inline">
                            <el-option v-for="num in 5" :value="num" :label="'第'+num+'顺位'"></el-option>
                        </el-select>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="选中" :prop="item.selected" required @click.native="getCurrentProp(item.selected)">
                            <el-upload :action="pictureActionUrl" :with-credentials='true' accept="image/*" name="picFile" type="drag" :thumbnail-mode="true"
                                :on-error="handleError" :on-success="handleSuccess">
                                <i class="el-icon-upload"></i>
                                <div class="el-dragger__text">将文件拖到此处，或
                                    <em>点击上传</em>
                                </div>
                            </el-upload>
                            <span class="gray">（尺寸说明：60x60像素，jpg、jpeg、GIF、png）</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="未选中" :prop="item.normal" required @click.native="getCurrentProp(item.normal)">
                            <el-upload :action="pictureActionUrl" :with-credentials='true' accept="image/*" name="picFile" type="drag" :thumbnail-mode="true"
                                :on-error="handleError" :on-success="handleSuccess">
                                <i class="el-icon-upload"></i>
                                <div class="el-dragger__text">将文件拖到此处，或
                                    <em>点击上传</em>
                                </div>
                            </el-upload>
                            <span class="gray">（尺寸说明：60x60像素，jpg、jpeg、GIF、png）</span>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
        </div>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mapActions } from 'vuex'
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                pictureActionUrl: this.$util.domain + '/api/v1/module/main/picture',
                edit: false,
                operatorId: '',
                currentProp: "",
                hours: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00",
                    "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
                    "13:00", "14:00", "15:00", "16:00", "17:00", "18:00",
                    "19:00", "20:00", "21:00", "22:00", "23:00"],
                items: [
                    { order: 1, type: 1, title: "运动ICON", selected: "selectedSport", normal: "normalSport" },
                    { order: 2, type: 2, title: "发现ICON", selected: "selectedFind", normal: "normalFind" },
                    { order: 3, type: 5, title: "福利社ICON", selected: "selectedWelfare", normal: "normalWelfare" },
                    { order: 4, type: 3, title: "动态ICON", selected: "selectedDynaic", normal: "normalDynaic" },
                    { order: 5, type: 4, title: "我的ICON", selected: "selectedMine", normal: "normalMine" }
                ],
                iconForm: {
                    description: "",
                    schObj: {
                        applicableCampus: "0",
                        shieldedSchools: [], //屏蔽的学校
                        openedSchools: []//应用的学校
                    },
                    selectedDynaic: "",
                    selectedWelfare: "",
                    selectedFind: "",
                    selectedMine: "",
                    selectedSport: "",
                    normalDynaic: "",
                    normalWelfare: "",
                    normalFind: "",
                    normalMine: "",
                    normalSport: "",
                    adExposingCodes: "",
                    qizhiDate: "yyyy/mm/dd",
                    startTime: new Date(),
                    sHours: "00:00",
                    endTime: new Date(),
                    eHours: "00:00",
                    id: ""
                },
                rules: {
                    description: [
                        { required: true, message: '请填写广告说明', trigger: 'blur' }
                    ],
                    selectedDynaic: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    selectedWelfare: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    selectedFind: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    selectedMine: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    selectedSport: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    normalDynaic: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    normalWelfare: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    normalFind: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    normalMine: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ],
                    normalSport: [
                        { required: true, message: '请上传图片', trigger: 'change' }
                    ]
                }
            }
        },
        mounted() {
            this.operatorId = this.$store.state.user.userId;

            let url = window.location.href;

            if (url.indexOf('?') !== -1) {
                this.edit = true;
                let id = this.$util.getUrlParam('id');
                this.getDetail(id);
            }
        },
        components: { selectSchool },
        methods: {
            ...mapActions(['SIGNOUT']),

            //获取子组件传递的参数
            getVal(res) {
                this.iconForm.schObj = res;
            },

            /**添加入口ICON**/
            add(num) {
                //收集表单数据；
                let startTime = new Date(this.iconForm.startTime).format("yyyy-MM-dd ") + this.iconForm.sHours;
                startTime = new Date(startTime);
                let endTime = new Date(this.iconForm.endTime).format("yyyy-MM-dd ") + this.iconForm.eHours;
                endTime = new Date(endTime);
                if (!this.iconForm.startTime || !this.iconForm.endTime) {
                    this.$util.errorMsg("请填写开始时间或结束时间");
                    return;
                }
                if (startTime.getTime() > endTime.getTime()) {
                    this.$util.errorMsg("请填写正确的结束时间");
                    return;
                }

                let rootUnids = [], iconList = [], schObj = this.iconForm.schObj;
                if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
                    for (let i = 0; i < schObj.shieldedSchools.length; i++) {
                        rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1)
                    }
                } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
                    for (let i = 0; i < schObj.openedSchools.length; i++) {
                        rootUnids.push(schObj.openedSchools[i].rootUnid * 1)
                    }
                }
                let orderArr = [];
                this.items.forEach(ele => {
                    if (!orderArr.includes(ele.order)) {
                        orderArr.push(ele.order)
                    }
                    iconList.push({
                        order: ele.order,
                        type: ele.type,
                        iconSelected: this.iconForm[ele.selected],
                        iconNormal: this.iconForm[ele.normal]
                    })
                })
                if (orderArr.length < 5) {
                    // 顺序有重复
                    this.$util.errorMsg("填写的位置顺序有重复！");
                    return;
                }
                // iconList = [
                //     {
                //         type: 1,//运动
                //         iconNormal: this.iconForm.normalSport,
                //         iconSelected: this.iconForm.selectedSport
                //     },
                //     {
                //         type: 2,//发现
                //         iconNormal: this.iconForm.normalFind,
                //         iconSelected: this.iconForm.selectedFind
                //     },
                //     {
                //         type: 3,//动态
                //         iconNormal: this.iconForm.normalDynaic,
                //         iconSelected: this.iconForm.selectedDynaic
                //     },
                //     {
                //         type: 4,//我的
                //         iconNormal: this.iconForm.normalMine,
                //         iconSelected: this.iconForm.selectedMine
                //     },
                //     {
                //         type: 5,//福利社
                //         iconNormal: this.iconForm.normalWelfare,
                //         iconSelected: this.iconForm.selectedWelfare
                //     }
                // ]

                let url = this.$util.domain + '/api/v1/module/main/editOrAdd';
                let requestBody = {
                    rootUnids,
                    iconList,
                    operateType: num * 1,//操作类型，0草稿，1发布
                    operatorId: this.operatorId * 1,// 管理员id
                    startTime: startTime.getTime(),
                    endTime: endTime.getTime(),
                    adExposingCode: this.iconForm.adExposingCodes,
                    description: this.iconForm.description,
                    applicableCampus: schObj.applicableCampus * 1,
                };
                if (this.edit) {
                    requestBody.id = this.$util.getUrlParam('id') * 1;
                }

                //发送ajax请求；
                this.$http({
                    url,
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                }).then(response => {
                    if (response.data.error === 10000) {
                        location.href = '/#/yunying/icon/iconManage';
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                }).catch(response => {
                    this.$util.errorMsg(response.data.message);
                })

            },
            //将详情中图片赋值给相应属性
            getDetImg(list) {
                let selectedDynaic, selectedFind, selectedMine, selectedSport, selectedWelfare,
                    normalDynaic, normalFind, normalMine, normalSport, normalWelfare;

                list.forEach(item => {
                    this.items.forEach(ele => {
                        if (ele.type == item.type) {
                            ele.order = item.order
                        }
                    })
                    switch (item.type) {
                        case 1:
                            selectedSport = item.iconSelected;
                            normalSport = item.iconNormal;
                            break;
                        case 2:
                            selectedFind = item.iconSelected;
                            normalFind = item.iconNormal;
                            break;
                        case 3:
                            selectedDynaic = item.iconSelected;
                            normalDynaic = item.iconNormal;
                            break;
                        case 4:
                            selectedMine = item.iconSelected;
                            normalMine = item.iconNormal;
                            break;
                        case 5:
                            selectedWelfare = item.iconSelected;
                            normalWelfare = item.iconNormal;
                            break;
                    }

                });

                return { selectedDynaic, selectedWelfare, selectedFind, selectedMine, selectedSport, normalDynaic, normalWelfare, normalFind, normalMine, normalSport };
            },
            // 获取入口ICON详情
            getDetail(id) {
                let url = this.$util.domain + '/api/v1/module/main/detail';

                this.$http({
                    url,
                    method: 'GET',
                    params: {
                        id: id * 1
                    }
                }).then((response) => {
                    //请求成功，进行赋值；
                    if (response.data.error === 10000) {
                        let data = response.data.data;
                        let iconList = this.getDetImg(response.data.data.iconList);

                        this.iconForm = {
                            id: data.id,
                            schObj: {
                                shieldedSchools: [], //屏蔽的学校
                                openedSchools: [], //应用的学校
                                applicableCampus: data.applicableCampus + ''
                            },
                            description: data.description,
                            selectedDynaic: iconList.selectedDynaic,
                            selectedWelfare: iconList.selectedWelfare,
                            selectedFind: iconList.selectedFind,
                            selectedMine: iconList.selectedMine,
                            selectedSport: iconList.selectedSport,
                            normalDynaic: iconList.normalDynaic,
                            normalWelfare: iconList.normalWelfare,
                            normalFind: iconList.normalFind,
                            normalMine: iconList.normalMine,
                            normalSport: iconList.normalSport,
                            adExposingCodes: data.adExposingCode,
                            startTime: new Date(data.startTime),
                            endTime: new Date(data.endTime),
                            sHours: new Date(data.startTime).format("hh:mm"),
                            eHours: new Date(data.endTime).format("hh:mm")
                        };
                        data.applicableCampus == 0 ? (this.iconForm.schObj.shieldedSchools = data.campusList) : (this.iconForm.schObj.openedSchools = data.campusList);
                    }
                })
            },
            //保存草稿或发布
            save(actionType) {
                //进行表单校验

                if (this.iconForm.schObj.applicableCampus == '1' && this.iconForm.schObj.openedSchools.length == 0) {
                    this.$util.errorMsg("请添加应用学校");
                    return;
                }
                //校验成功，调用添加ICON方法；
                this.$refs.iconForm.validate((valid) => {
                    if (valid) {
                        if (actionType == 0) {
                            this.add(0);
                        } else {
                            this.add(1);
                        }
                    }
                })
            },
            //取消
            cancel() {
                history.go(-1);
            },
            getCurrentProp(prop) {
                this.currentProp = prop;
            },
            //上传picture文件成功钩子
            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    let currentProp = this.currentProp;
                    this.iconForm[currentProp] = response.data + "";
                }
            },
            //上传文件失败钩子
            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = '/#';
                }
                this.$util.errorMsg('上传失败');
            }
        }
    }

</script>

<style>
    .inline {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    .btn_newIcon+.btn_newIcon {
        margin-left: 0;
    }

    .iconTitle {
        width: 40%;
    }

    .timeInput {
        width: 300px;
    }

    .newIcon .irregular {
        display: inline-block;
    }

    .gray {
        color: #999;
    }

    .newIcon .time {
        display: inline-block;
        width: 15%;
    }

    div.tit {
        height: 66px;
        vertical-align: middle;
        font-size: 14px;
        color: #5e6d82;
        padding: 11px 12px 11px 0;
        box-sizing: border-box;
    }

    div.tit span {
        display: inline-block;
        width: 130px;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// newIcon.vue?0f40ee91